module.exports = __webpack_public_path__ + "img/AICAD_LOGO_TRANSPARENTE_NEGRO.fw.f722cb2e.png";